import * as actions from '../actions/actionTypes';

const initialState = {
  tasks: [],
};

const fetchTaskSchedulesSuccess = (state, action) => ({ ...state, tasks: action.tasks });

const updateTaskScheduleNameSuccess = (state, action) => {
  const updatedTaskSchedule = state.tasks.map((taskschedule) => {
    if (taskschedule.id === action.id) {
      const updatedTask = taskschedule;
      updatedTask.statusaction = action.name;
      updatedTask.description = action.description;
      return updatedTask;
    }
    return taskschedule;
  });
  return {
    ...state,
    tasks: updatedTaskSchedule,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_TASK_SCHEDULES_SUCCESS: return fetchTaskSchedulesSuccess(state, action);
    case actions.UPDATE_TASK_SCHEDULES_SUCCESS: return updateTaskScheduleNameSuccess(state, action);

    default: return state;
  }
};

export default reducer;
